import React, { Component } from "react";
// @material-ui/core components

import { EmptyRecord } from "../../utils/PageUtility";
import { appHelpers } from "../../_helpers";

import {
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import RecordPagination from "../../utils/RecordsPagination";

const SettingTableStructure = ({
  filterAirport,
  classes,
  records,
  filterUsers,
  user,
  filterAirlines,
  handleEdit,
  pageIndex,
}) => (
  <Table className={classes.table} aria-labelledby="tableTitle">
    <TableHead className={classes.negativeColor} color="regional">
      <TableRow>
        <TableCell padding="none">S/N</TableCell>
        <TableCell padding="none">Airline</TableCell>
        <TableCell padding="none">Airport</TableCell>
        <TableCell padding="none">Re-order Amount</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {records &&
        records.map((item, key) => {
          return (
            <TableRow hover key={pageIndex + key}>
              <TableCell padding="none" component="th">
                {pageIndex + key}
              </TableCell>
              <TableCell padding="none" className={"text-capitalize"}>
                {filterAirlines(item.AirlineId)}
              </TableCell>
              <TableCell padding="none" className={"text-capitalize"}>
                {filterAirport(item.AirportCode)}
              </TableCell>
              <TableCell padding="none" className={"text-capitalize"}>
              { `${item.Currency} ${appHelpers.numberWithCommas(item.Amount)}`}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  </Table>
);

class SettingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      flight: false,
    };
  }

  handleClickOpen = (flight) => {
    this.setState({ open: true });
    this.setState({ flight });
    this.props.fetchFlightPassengers(flight.Id);
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      filterAirport,
      totalCounts,
      fetchRecords,
      pageSize,
      currentPage,
      classes,
      handleEdit,
      filterUsers,
      filterAirlines,
      user,
      records,
    } = this.props;
    const pageIndex = pageSize * (currentPage - 1) + 1;

    if (totalCounts === 0)
      return <EmptyRecord message={"No Minimum Re-order Level yet!"} />;
    // if(searchError)
    //     return (<EmptyRecord message={searchError}/>);
    return (
      <div>
        <div className={classes.tableResponsive} style={{ overflowX: "auto" }}>
          <RecordPagination
            fetchMore={fetchRecords}
            totalCount={totalCounts}
            pageSize={pageSize}
            currentPage={currentPage}
            target={
              <SettingTableStructure
                records={records}
                classes={classes}
                filterAirport={filterAirport}
                pageIndex={pageIndex}
                filterAirlines={filterAirlines}
                filterUsers={filterUsers}
                handleEdit={handleEdit}
                user={user}
              />
            }
          />
        </div>
        {/*<div className={classes.tableResponsive} style={{ overflowX: "auto" }}>*/}
        {/*<SettingTableStructure records={records} classes={classes} filterAirlines={filterAirlines} filterUsers={filterUsers} handleEdit={handleEdit} user={user}/>*/}
        {/*</div>*/}
      </div>
    );
  }
}

export default SettingsTable;



// WEBPACK FOOTER //
// ./src/Regional-Views/Settings/settingsTable.js